import React from 'react';
import ViewMessage from '@components/ViewMessage';
import { XIcon } from '@components/Icons';

export const NoResultsFound = () => (
  <ViewMessage
    underHeader
    icon={<XIcon width={18} height={18} strokeWidth={1.8} />}
    headline="No matches found"
    message={
      <>
        Your search did not return any
        <br />
        results.
      </>
    }
  />
);
